import { render, staticRenderFns } from "./LayoutColumn.vue?vue&type=template&id=81650586&"
import script from "./LayoutColumn.vue?vue&type=script&lang=js&"
export * from "./LayoutColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81650586')) {
      api.createRecord('81650586', component.options)
    } else {
      api.reload('81650586', component.options)
    }
    module.hot.accept("./LayoutColumn.vue?vue&type=template&id=81650586&", function () {
      api.rerender('81650586', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/layout/LayoutColumn.vue"
export default component.exports